import { proxyApiMnemo } from './common';
import { mnemoService } from 'libs/api';

export const digcompService = {
    getDIGCOMPCodes(rCode) {
        const payload = mnemoService.buildPayload('codes', 'rCode', rCode);
        return proxyApiMnemo.get('/digcomp/?payload=' + encodeURI(payload));
    },
}

